// extracted by mini-css-extract-plugin
export default {"container":"Loja_container__BZw5V"};